<template>
  <div></div>
</template>
<script>
import { GetPayData, GetItem } from "@/services/getData.js";
import weui from "weui.js";
export default {
  data() {
    return {};
  },
  created() {
    this.mobilePay();
  },
  methods: {
    mobilePay() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "正在努力跳转..."
      });
      const mode = {};
      const OpenId = GetItem("openid");
      const url = this.$route.fullPath.split("?")[1];
      const kv = url.split("&");
      for (var i = 0; i < kv.length; i++) {
        const valueKey = kv[i].split("=")[0];
        const value = kv[i].split("=")[1];
        mode[valueKey] = value;
        mode.OpenId = OpenId;
        mode.ItemIds = "0202";
      }
      GetPayData(mode).then(res => {
        if (res.data.Result == false && res.data.Extend == "AuthCode") {
          this.$router.push({
            path: "/empowerOver"
          });
          loading.hide();
          return false
        } else if (res.data.Result == false && res.data.Extend != "AuthCode") {
          alert(res.data.Content);
          loading.hide();
          return false
        } else {
          window.location.href = res.data.Extend;
          loading.hide();
        }
      });
    }
  }
};
</script>
<style scoped>
.btn {
  width: 150px;
  height: 80px;
  background: #5cd9ce;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/setmidey/setmidey.vue